module.exports = __webpack_public_path__ + "static/media/Filter.1614b072.svg";